export default __webpack_public_path__ + "002ae3a46f62b994d033cf01afeadf2c.png";